/**
 * /tenants/$slug/authentication/conditional-access — route shim.
 *
 * Prefetches the conditional-access policy list, the cross-app
 * access roster, and the named-locations list so the unified
 * page renders all three sections without a spinner on the
 * primary data.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchPoliciesList } from "@/features/policies/queries";
import { fetchAccessRoster } from "@/features/policies/app-access-queries";
import { fetchNamedLocations } from "@/features/named-locations/queries";
import { queryKeys } from "@/lib/query-keys";
import { PoliciesListPage } from "@/features/policies/pages/policies-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/conditional-access/")({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.policies.list(context.tenant.id),
        queryFn: () => fetchPoliciesList(context.tenant.id),
      }),
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.applications.accessRoster(context.tenant.id, {}),
        queryFn: () => fetchAccessRoster(context.tenant.id, {}),
      }),
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.namedLocations.list(context.tenant.id),
        queryFn: () => fetchNamedLocations(context.tenant.id),
      }),
    ]),
  component: PoliciesListPage,
});
